export default __webpack_public_path__ + "static/media/Warning_off.1f506de7.svg";